var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toolPage"},[_c('div',{staticClass:"tool_item flex-rowc",on:{"click":_vm.handleScreen}},[_c('i',{staticClass:"iconfont icon-liebiaofenlei"})]),_c('div',{staticClass:"tool_item flex-rowc",on:{"click":_vm.handleTop}},[_c('i',{staticClass:"iconfont icon-toTop"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }